'use client';

import {inter} from '@lib/fonts';
import {themeWithChakra} from '@linx-security/ui/theme';
import {UIThemeProvider, cookieStorageManagerSSR, localStorageManager, uiTheme} from '@linx-security/ui';
import {GraphNodeTheme, GraphTheme} from '@modules/graph/theme';
import {deepmerge} from 'deepmerge-ts';
import type {PropsWithChildren} from 'react';
import {useMemo} from 'react';

type Props = PropsWithChildren<{
  colorModeCookie?: string;
  newUIEnabled?: boolean;
}>;

// Those existing in both themes for migration purposes
const commonTheme = {
  fontWeights: uiTheme.fontWeights,
  fontSizes: uiTheme.fontSizes,
  lineHeights: uiTheme.lineHeights,
  colors: uiTheme.colors,
  sizes: uiTheme.sizes,
  shadows: uiTheme.shadows,
  styles: {
    global: uiTheme.styles.global,
  },
  components: {
    Graph: GraphTheme,
    GraphNode: GraphNodeTheme,
    ...uiTheme.components,
  },
  semanticTokens: {
    colors: uiTheme.semanticTokens.colors,
  },
};

export const StylesProvider = ({children, colorModeCookie, newUIEnabled}: Props) => {
  const colorModeManager = colorModeCookie ? cookieStorageManagerSSR(colorModeCookie) : localStorageManager;

  const appTheme = useMemo(() => deepmerge(newUIEnabled ? uiTheme : themeWithChakra, commonTheme), [newUIEnabled]);

  return (
    <UIThemeProvider colorModeManager={colorModeManager} theme={appTheme}>
      <style jsx global>
        {`
          :root {
            --font-inter: ${inter.style.fontFamily};
          }
        `}
      </style>
      {children}
    </UIThemeProvider>
  );
};
